import React, { useEffect, useRef, useState } from "react";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Esercizio } from "../interfaces/Esercizio";
import DeleteIcon from '@mui/icons-material/Delete';
//import { Canvas } from '@react-three/fiber';
//import { useLoader } from '@react-three/fiber';
//import { USDZLoader } from 'three/examples/jsm/loaders/USDZLoader';
import { Chip, Box } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

interface Video3DTrackProps {
  title: string;
  description: string;
  acceptedFileType?: string;
  file: File | string | null;
  field: keyof Esercizio;
  handleChange: <K extends keyof Esercizio>(key: K, value: Esercizio[K]) => void;
  fast?: boolean;
  filename: string | null;
}

const Video3DTrack: React.FC<Video3DTrackProps> = ({ title, description, acceptedFileType, file, field, handleChange, fast, filename }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [modelURL, setModelURL] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (modelURL) {
      return () => {
        URL.revokeObjectURL(modelURL);
      };
    }
  }, [modelURL]);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0] || null;

    if (selectedFile) {
      handleChange(field, selectedFile);
      handleChange("filename_animation", selectedFile.name);
      //const reader = new FileReader();
      //reader.onload = () => {
      //  setModelURL(reader.result as string);
      //};
      //reader.readAsDataURL(selectedFile);
      const url = URL.createObjectURL(selectedFile);
      setModelURL(url);
    } else {
      setModelURL(undefined);
    }
  };

  const handleRemoveFile = () => {
    setModelURL(undefined);
    handleChange(field, null);
    handleChange("filename_animation", null);
  };

  const handleDownload = async () => {
    try {
      if(file && typeof file == 'string' && filename){
          const response = await fetch(file, {
            method: "GET",
          });

          if (!response.ok) {
            throw new Error("Errore durante il download");
          }

          const blob = await response.blob();
          const url = window.URL.createObjectURL(blob);

          const a = document.createElement("a");
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();

          a.remove();
          window.URL.revokeObjectURL(url);
        }
    } catch (err) {
      console.error(err);
    }
  }

  const handleChangeFile = () => {
    setModelURL(undefined);
    handleRemoveFile();
    fileInputRef.current?.click();
  };

  /*
  const Model = ({ url }: { url: string }) => {
    const model = useLoader(USDZLoader, url);
    return <primitive object={model} scale={0.5} />;
  };*/

  return (
    <>
      <h5 className="text-lg font-semibold">{title}</h5>
      {fast ? (
        <>
          <input
            type="file"
            accept={acceptedFileType || ".usdc,.usdz"}
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          {!file && (

            <button
              className="btn flex gap-2 mb-4 btn-light"
              style={{ backgroundColor: "#e7e7e7", color: "black" }}
              onClick={handleButtonClick}>
              <FileUploadIcon />
              Carica file
            </button>
          )}
          {file && (<>
            <Chip
              //label={typeof file === "string" ? file.split('/').pop() : "Video caricato"}
              label={filename}
              onDelete={handleRemoveFile}
              onClick={handleDownload}
              deleteIcon={
                <Box
                  sx={{
                    backgroundColor: 'black',
                    borderRadius: '50%',
                    padding: '2px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CloseIcon sx={{ color: 'white', fontSize: 18 }} />
                </Box>
              }
              sx={{
                cursor: 'default',
                '&:hover': {
                  cursor: 'pointer',
                },
                backgroundColor: 'black',
                color: 'white',
              }}
            />
          </>
          )}
        </>
      ) : (
        <>
          <p className="text-sm" style={{ color: "gray" }}>{description}</p>
          <div className="text-center">
            <input
              type="file"
              accept={acceptedFileType || ".usdc,.usdz"}
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            {file ? (
              <>
                <div className="border p-3 rounded-3 bg-light" >
                  <div className="text-center m-1">
                    <Chip
                      //label={typeof file === "string" ? file.split('/').pop() : "File caricato"}
                      label={filename}
                      onDelete={handleRemoveFile}
                      onClick={handleDownload}
                      deleteIcon={
                        <Box
                          sx={{
                            backgroundColor: 'black',
                            borderRadius: '50%',
                            padding: '2px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <CloseIcon sx={{ color: 'white', fontSize: 18 }} />
                        </Box>
                      }
                      sx={{
                        cursor: 'default',
                        '&:hover': {
                          cursor: 'pointer',
                        },
                        backgroundColor: 'black',
                        color: 'white',
                      }}
                    />
                  </div>
                  {/*
              <Canvas style={{ height: '300px', width: '100%' }}>
                <ambientLight />
                <spotLight position={[10, 10, 10]} />
                <Model url={modelURL} />
              </Canvas>
              */}
                </div>
              </>
            ) : (<>

              <div className="border p-3 rounded-3 bg-light" >
                <p>Trascina e rilascia <br />o</p>
                <button className="btn flex items-center gap-2 mb-4" style={{ backgroundColor: "#1c492d", color: "white" }} onClick={handleButtonClick}>
                  <FileUploadIcon />
                  Carica file
                </button>
                <p className="text-sm" style={{ color: "gray" }}>Nessun file caricato</p>
              </div>
            </>
            )}
          </div>
        </>)}
    </>
  );
};

export default Video3DTrack;